// src/utils/models/invoiceModel.js

export const INVOICE_STATUS = {
  DRAFT: "draft",
  SENT: "sent",
  PAID: "paid",
  OVERDUE: "overdue",
  CANCELLED: "cancelled",
};

export const INVOICE_TYPE = {
  NORMAL: "normal",
  PROFORMA: "proforma",
  ABONO: "abono",
  LIQUIDACION: "liquidacion",
};

export const INVOICE_TYPE_LABELS = {
  normal: "Factura",
  proforma: "Factura Proforma",
  abono: "Abono",
  liquidacion: "Liquidación",
};

// Modo de liquidación (solo aplica a invoiceType === LIQUIDACION)
export const LIQUIDATION_MODE = {
  PROJECT: "project",
  SWITCH: "switch",
};

export const LIQUIDATION_MODE_LABELS = {
  project: "Proyecto",
  switch: "Cambio de comercializadora",
};

export const PAYMENT_METHODS = {
  TRANSFER: "transfer",
  CASH: "cash",
};

export const PAYMENT_METHOD_LABELS = {
  transfer: "Transferencia",
  cash: "Al contado",
};

export const createInvoiceLine = (data = {}) => ({
  id: data.id || "",
  description: data.description || "",
  quantity: data.quantity || 1,
  unitPrice: data.unitPrice || 0,
  taxRate: data.taxRate || 21,
  total: data.total || 0,
  taxAmount: data.taxAmount || 0,
  projectId: data.projectId || null,
});

// Línea específica de liquidación por proyecto (mantiene compatibilidad)
export const createLiquidationProjectLine = (data = {}) => ({
  id:
    data.id ||
    `liq_line_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  projectId: data.projectId || null,
  projectName: data.projectName || "",
  quarter: data.quarter || "Q1",
  commission: data.commission || 0,
});

// Línea específica de liquidación de cambio de comercializadora
export const createLiquidationSwitchLine = (data = {}) => ({
  id:
    data.id ||
    `liq_sw_line_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
  switchClientId: data.switchClientId || "",
  switchClientName: data.switchClientName || "",
  cups: data.cups || "",
  fechaEntrada: data.fechaEntrada || "",
  commission: data.commission || 0,
});

export const createInvoice = (data) => ({
  id: "",

  // Tipo de factura
  invoiceType: data.invoiceType || INVOICE_TYPE.NORMAL,

  // Modo de liquidación (project | switch). Solo aplica a liquidaciones.
  liquidationMode:
    data.liquidationMode ||
    (data.invoiceType === INVOICE_TYPE.LIQUIDACION
      ? LIQUIDATION_MODE.PROJECT
      : ""),

  // Número de factura
  invoiceNumber: data.invoiceNumber || "",

  // Fracciones de proforma
  proformaNumber: data.proformaNumber || "",
  fraction: data.fraction || "", // "", "A", "B", "C"...

  // Cliente (receptor)
  clientId: data.clientId || "",
  clientName: data.clientName || "",
  clientTaxId: data.clientTaxId || "",
  clientEmail: data.clientEmail || "",
  clientAddress: data.clientAddress || "",

  // Emisor (siempre EPC)
  issuerName: data.issuerName || "EPC Development & Management, S.L.",
  issuerTaxId: data.issuerTaxId || "B26623850",
  issuerAddress: data.issuerAddress || "C/ Juan de Austria 13, Cox, Alicante",

  // Líneas de factura
  lines: data.lines || [],

  // Totales (calculados a partir de las líneas)
  baseAmount: data.baseAmount || 0,
  taxRate: data.taxRate || 21,
  taxAmount: data.taxAmount || 0,
  total: data.total || 0,

  // Fechas
  issueDate: data.issueDate || new Date().toISOString(),
  dueDate: data.dueDate || "",

  // Forma de cobro
  paymentMethod: data.paymentMethod || PAYMENT_METHODS.TRANSFER,
  iban: data.iban || "ES31 0182 4428 1602 0155 9169",

  // Estado
  status: data.status || INVOICE_STATUS.DRAFT,

  // Metadata
  notes: data.notes || "",
  salesInvoiceId: data.salesInvoiceId || null,
  purchaseInvoiceId: data.purchaseInvoiceId || null,

  // Trazabilidad de conversión
  convertedToInvoiceId: data.convertedToInvoiceId || null,
  convertedAt: data.convertedAt || null,

  // Grupo de conversión (para agrupar fracciones convertidas en una sola factura)
  conversionGroupId: data.conversionGroupId || null,

  sentAt: null,
  paidAt: null,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  createdBy: "",
  isActive: true,
});